module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kd-La.f3d26282.png";